<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from "@/components/landingPage/ui/card";
import { Badge } from "@/components/landingPage/ui/badge";

interface HowItWorksProps {
  badgeTitle: string;
  title: string;
  description: string;
  image: string;
}

const HowItWorksList: HowItWorksProps[] = [
  {
    badgeTitle: "Étape 1",
    title: "Créez votre profil personnalisé",
    description:
      "Créez votre avatar et complétez votre profil initial. Choisissez votre genre, style, humeur, passions et couleurs préférées dans un processus d'onboarding inclusif.",
    image: "roboto.png",
  },
  {
    badgeTitle: "Étape 2",
    title: "Découvrez vos forces à travers le jeu",
    description:
      "Participez à des mini-jeux ludiques pour révéler vos compétences : jeu des scénarios, suites logiques, métiers, vitesse, roue des compétences et environnement de travail.",
    image: "runner.png",
  },
  {
    badgeTitle: "Étape 3",
    title: "Recevez des recommandations IA",
    description:
      "L'algorithme de matching intelligent analyse vos résultats pour recommander des métiers, formations et entreprises compatibles avec votre profil unique.",
    image: "pacheco.png",
  },
  {
    badgeTitle: "Étape 4",
    title: "Construisez votre avenir professionnel",
    description:
      "Postulez à des stages et apprentissages, suivez vos candidatures et progressez avec l'accompagnement de professionnels spécialisés dans la neurodiversité.",
    image: "gamestation.png",
  },
];
</script>

<template>
  <section
    id="features"
    class="container mx-auto py-24 sm:py-32"
  >
    <div class="text-center mb-8">
      <h2 class="text-lg text-[#ff9500] text-center mb-2 tracking-wider">
        Comment ça marche
      </h2>

      <h2 class="text-3xl md:text-4xl text-center font-bold">
        Votre parcours en 4 étapes
      </h2>
    </div>

    <div class="lg:w-[80%] mx-auto relative">
      <div
        v-for="(
          { badgeTitle, title, description, image }, index
        ) in HowItWorksList"
        :key="title"
        :class="[
          'flex mb-8 items-center',
          { ' flex-row-reverse': index % 2 !== 0 },
        ]"
      >
        <Card class="h-full bg-transparent border-0 shadow-none">
          <CardHeader>
            <div class="pb-4">
              <Badge>{{ badgeTitle }}</Badge>
            </div>

            <CardTitle>
              {{ title }}
            </CardTitle>
          </CardHeader>

          <CardContent class="text-muted-foreground w-[80%]">
            {{ description }}
          </CardContent>
        </Card>

        <img
          :src="image"
          :alt="`Image describing ${title} `"
          className="w-[150px]  md:w-[250px] lg:w-[300px] mx-auto -scale-x-100 "
        />
        <div
          :class="[
            '-z-10 absolute right-0 w-44 h-72  lg:w-64 lg:h-80 rounded-full bg-[#ff9500]/15 dark:bg-[#ff9500]/10 blur-3xl',
            {
              'left-0': index % 2 !== 0,
            },
          ]"
        ></div>
      </div>
    </div>
  </section>
</template>
